import { render, staticRenderFns } from "./CnabReturnsUploadListTable.vue?vue&type=template&id=1fcd75d4&"
import script from "./CnabReturnsUploadListTable.vue?vue&type=script&lang=js&"
export * from "./CnabReturnsUploadListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports